import { useTranslation } from 'react-i18next';
import { ServicePage } from './ServicePage';

/** `/guide`, the footer's "Guida": a provisional guide, marked as such (`ServicePage`). */
export function GuidePage() {
  const { t } = useTranslation('shell');

  return (
    <ServicePage
      title={t('nav.guide')}
      summary={t('servicePages.guide.summary')}
      note={t('servicePages.guide.note')}
      sections={[
        {
          id: 'sign-in',
          title: t('servicePages.guide.signIn.title'),
          paragraphs: [t('servicePages.guide.signIn.body')],
        },
        {
          id: 'context',
          title: t('servicePages.guide.context.title'),
          paragraphs: [t('servicePages.guide.context.body')],
        },
        {
          id: 'modules',
          title: t('servicePages.guide.modules.title'),
          paragraphs: [t('servicePages.guide.modules.body')],
          items: [
            t('servicePages.guide.modules.clinicalStudy'),
            t('servicePages.guide.modules.finance'),
            t('servicePages.guide.modules.identityDocuments'),
            t('servicePages.guide.modules.administration'),
          ],
        },
        {
          id: 'search',
          title: t('servicePages.guide.search.title'),
          paragraphs: [t('servicePages.guide.search.body')],
        },
        {
          id: 'preferences',
          title: t('servicePages.guide.preferences.title'),
          paragraphs: [t('servicePages.guide.preferences.body')],
        },
        {
          id: 'install',
          title: t('servicePages.guide.install.title'),
          paragraphs: [t('servicePages.guide.install.body')],
          items: [
            t('servicePages.guide.install.android'),
            t('servicePages.guide.install.ios'),
            t('servicePages.guide.install.mac'),
          ],
        },
        {
          id: 'notices',
          title: t('servicePages.guide.notices.title'),
          paragraphs: [t('servicePages.guide.notices.body')],
        },
      ]}
    />
  );
}
